export const styles = {
  container: {
    bgcolor: 'var(--lia-popup-background-message)',
    borderRadius: '12px',
    p: 3,
    boxShadow: 2,
    maxWidth: '400px',
    width: '100%',
    mx: 'auto',
    my: 2,
  },
  title: {
    textAlign: 'center',
    mb: 2,
    color: 'var(--title-font-color-black-10)',
    fontWeight: 600,
  },
  description: {
    textAlign: 'center',
    mb: 3,
    color: 'var(--color-body-1)',
  },
  ratingContainer: {
    display: 'flex',
    justifyContent: 'center',
    mb: 3,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  submitButton: {
    bgcolor: '#3f4372',
    '&:hover': {
      bgcolor: '#2c2f51',
    },
  },
  dismissButton: {
    color: '#666',
    '&:hover': {
      bgcolor: 'transparent',
      color: '#28272C',
    },
  },
} as const; 